export const ModalBackDrop = { backdropFilter: 'blur(6px)' };
export const PromaxoBlue = { bgcolor: '#303030' };
